<template>
    <div class="edit-content cartoon-content f-hidden"></div>
</template>

<script>
export default {
    name: 'cartoon_create.vue'
}
</script>

<style scoped>

</style>
